(function($){

	let contactForm = $('#bar-contact');

	if(!contactForm || contactForm.length < 1){
		return;
	}

	contactForm.validate({

        ignore: [],
        rules: {
			"bar-contact-name" : {
	            required: true,
	        },
	        "bar-contact-email" : {
	            required: true,
	            email: true,
	        },
	        "bar-contact-subject" : {
	            required: true,
	        },
	        "bar-contact-message" : {
	            required: true,
	        },
        },
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest(".bar-form-field").find('.bar-form-feedback') );
        },
        highlight: function(element) {
            $(element).closest(".bar-form-input").addClass('bar-form-input--has-error');
        },
        unhighlight: function(element) {
            $(element).closest(".bar-form-input").removeClass('bar-form-input--has-error');
        },

        submitHandler: function(form){

            $.ajax({
		        type: "POST",
		        dataType: "json",
		        url: var_bar_ajax.url,
		        data: {
		        	action : var_bar_ajax.action,
					nonce: var_bar_ajax.nonce,
					callback: 'bar-send-contact-form',
					formData: $(form).serialize(),
		        },
		        success: function(response){
		        	$(form).find('.bar-alert').addClass('bar-alert--success').append( response );
		        	$(form).find('.bar-form-alert').addClass('bar-form-alert--is-visible');
		        	$(form)[0].reset();
		        },
		        error : function(jqXHR, textStatus, errorThrown) {
		        	$(form).find('.bar-alert').addClass('bar-alert--error').append( response );
		        	$(form).find('.bar-form-alert').addClass('bar-form-alert--is-visible');
		        	console.log(errorThrown);
		        }

		    }); // $.ajax
        }
    });

})(jQuery)